<template>
  <div class="timeOfCapital-view">
    <div class="nyTit">
      <i></i>
      {{ $t("loan.fundFlowData") }}
      <sbutton
        v-if="showEditBtn && !finalLoan"
        @click.native="editDateClick()"
        style="float: right">{{ $t("poolOfMoney_page.updateDate") }}</sbutton>
    </div>
    <table border="0" cellpadding="0" cellspacing="0" class="nyFormTb" style="width: 1020px; margin-bottom: 10px">
      <tr class="tr1">
        <!--录入时间-->
        <td class="td1" width="205">{{ $t("poolOfMoney_page.auditOpinion") }}</td>
        <!--预计开始时间-->
        <td class="td2" width="295">{{ $t("poolOfMoney_page.estimateStartDate") }}</td>
        <!--预计到期时间-->
        <td class="td3" width="280">{{ $t("poolOfMoney_page.estimateEndDate") }}</td>
        <!--天数-->
        <td class="td3">{{ $t("loan.numberOfDay") }}</td>
      </tr>
      <tr v-for="(item,index) in timeList" :key="index">
        <td>
          <div class="line1Oh">
            {{item.createTime | dateConvert}}
          </div>
        </td>
        <td>
          <div class="line1Oh">
            {{item.estimateStartDate | dateConvert}}
          </div>
        </td>
        <td>
          <div class="line1Oh">
            {{item.estimateEndDate | dateConvert}}
          </div>
        </td>
        <td>
          <div class="line1Oh">
            {{item.intervalDay}}
          </div>
        </td>
      </tr>
    </table>

<!--     修改日期对话框-->
    <el-dialog
      :title="$t('loan.fundFlowData')"
      :visible.sync="editDateDialogVisible"
      width="500px"
      @close="editDateDialogClosed"
      custom-class="tipPop tipDialog timeDialog"
    >
      <div class="time-body">
        <el-form
          class="time-form"
          :model="addUserForm"
          ref="addUserFormRef"
          :rules="rules"
          label-width="120px"
        >
          <el-form-item
            :label="$t('loan.expectStartDate')"
            prop="estimateStartDate"
            class="theme-default w520"
            style="margin-bottom:20px; padding:0;"
          >
            <el-date-picker
              v-model="addUserForm.estimateStartDate"
              type="date"
              class="theme-default w520"
              :placeholder="$t('financingFundList.enterPlaceHolder')"
            >
            </el-date-picker>
          </el-form-item>
          <!--                  预计到期日期-->
          <el-form-item
            :label="$t('loan.expectDueDate')"
            prop="estimateEndDate"
            style="margin-bottom:10px; padding:0;">
            <el-date-picker
              v-model="addUserForm.estimateEndDate"
              type="date"
              class="theme-default w520"
              :placeholder="$t('financingFundList.enterPlaceHolder')"
            >
            </el-date-picker>
          </el-form-item>
          <!--                  天数-->
          <el-form-item
            prop="numberOfDay"
            v-model="addUserForm.numberOfDay"
            style="margin-bottom:10px; padding:0;"
            :label="$t('loan.numberOfDay')">
            {{day}} {{$t('frontPage.day')}}
          </el-form-item>
        </el-form>
      </div>
      <div class="time-foot">
        <el-button
          class="mail-btn-default"
          @click="editDateDialogVisible = false"
        >{{ $t("poolOfMoney_page.no") }}
        </el-button>
        <el-button
          class="mail-btn-primary"
          @click="submitForm('addUserFormRef')"
        >{{ $t("poolOfMoney_page.ok") }}</el-button
        >

      </div>

    </el-dialog>

  </div>
</template>

<script>
import Sbutton from "../Sbutton";
import mixins from '@/helper/mixins.js';
export default {
  name:'timeOfCapitalFlow',
  mixins:[mixins],
  components: {
    Sbutton,
  },
  props: [],
  data(){
    return {
      finalLoan:0,
      timeList:[],
      flowNumber:'',
      showEditBtn:'',
      editDateDialogVisible:false,
      addUserForm: {
        estimateStartDate:'',
        estimateEndDate:'' ,
        numberOfDay:'',
      },
      rules:{
        estimateStartDate: [{ required: true, message: this.$t('financing.pleaseWrite'), trigger: 'blur' }],
        estimateEndDate:[{ required: true, message: this.$t('financing.pleaseWrite'), trigger: 'blur' }],
        // numberOfDay:[{ required: true, message: this.$t('financing.pleaseWrite'), trigger: 'blur' }],
      },
    }
  },
  computed: {
    day(){
      if(this.$utils.isObjFn(this.addUserForm)){
        let estimateStartDate=this.addUserForm.estimateStartDate
        let estimateEndDate=this.addUserForm.estimateEndDate
        if(estimateStartDate && estimateEndDate){
          let startDateTime=estimateStartDate.getTime();
          let endDateTime=estimateEndDate.getTime();
          return  (endDateTime-startDateTime)/(1000 * 3600 * 24)
        }
        else{
          return 0;
        }
      } else {
        return 0;
      }
    },
  },
  methods:{

    initData(obj){
      this.finalLoan = parseInt(window.sessionStorage.getItem('finalLoan'));
      this.timeList = obj.zmaUpdateTimeLogs
      let firstTime = this.timeList[0]
      if (firstTime){
        this.addUserForm.estimateStartDate = new Date(firstTime.estimateStartDate)
        this.addUserForm.estimateEndDate = new Date(firstTime.estimateEndDate)
      }

      if(obj.isComplete){
        this.showEditBtn = false;
        return false;
      }

      if(this.isSuper()){
        this.showEditBtn = true;
        return false
      }

      this.getMenu().then(data => {
        this.showEditBtn = data.indexOf(8) > -1 ? true : false;
      })
    },
    submitForm(formName){
      let _this = this
      this.$refs[formName].validate((valid) => {
        if (valid){
          if (_this.addUserForm.estimateStartDate.getTime() >= _this.addUserForm.estimateEndDate.getTime()){
            this.$message.error(this.$t(`error.forfait_estimateDay`))
            return false
          }
          let params = {
            flowNumber:_this.flowNumber,
            estimateStartDate:_this.addUserForm.estimateStartDate.toString(),
            estimateEndDate:_this.addUserForm.estimateEndDate.toString()
          }
          this.axios.post("capital/zmaAdjustTime", params)
            .then(res => {
              console.log(res);
              if (res.status) {
                console.log("修改日期成功");
                _this.$emit('confirmClick');   //回调，刷新界面
              } else {
                this.$message.error(
                  this.$t(`poolOfMoney_error.${res.errorCode}`)
                );
                if (res.errorCode == "loan_audit_50000031") {
                  setTimeout(function() {
                    window.location.reload();
                  }, 1500);
                }
              }
            });
          this.editDateDialogVisible = false;
        }

      });
    },

    editDateClick(){
      this.editDateDialogVisible = true
    },
    editDateDialogClosed(){
      this.$refs.addUserFormRef.resetFields();
    },

  },

  mounted() {
    this.flowNumber = this.$route.query.f_n || this.$route.query.in_id;
  }
}
</script>

<style lang="scss" scoped>

.timeDialog{
  .el-form-item{
    el-form-item__label {
      text-align: left;
      color: red;
    }
  }
}

.ny-right-btn {
  width: 150px;
  height: 38px;
  background: #7996f5;
  border-radius: 2px;
  color: #fff;
  float: right;
}

.time-body{
  .time-form{
    margin-top: 20px;
    //background-color: red;
    border-bottom: 1px solid #dddddd;
  }

}
.time-foot{
  display: flex;
  //flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 16px 0;
  //background-color: green;
}

.mail-btn-primary{
  width: 150px;
  height: 38px;
  background: #7996f5;
  border-radius: 2px;
  color: #fff;
}
.mail-btn-default {
  width: 150px;
  height: 38px;
  background: #ffffff;
  border: 1px solid #7996f5;
  border-radius: 2px;
  color: #7996f5;
}
</style>
